/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_Martial_ArtsInputs */

const en_us2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Martial arts`)
};

const pt_br2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artes marciais`)
};

const es_419_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artes marciales`)
};

const pt_pt2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artes marciais`)
};

const fr_fr2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arts martiaux`)
};

const de_de2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampfsport`)
};

const it_it2_modality_martial_arts = /** @type {(inputs: Modality_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arti marziali`)
};

/**
* | output |
* | --- |
* | "Martial arts" |
*
* @param {Modality_Martial_ArtsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_martial_arts = /** @type {((inputs?: Modality_Martial_ArtsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_Martial_ArtsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_martial_arts(inputs)
	if (locale === "es-419") return es_419_modality_martial_arts(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_martial_arts(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_martial_arts(inputs)
	if (locale === "de-DE") return de_de2_modality_martial_arts(inputs)
	if (locale === "it-IT") return it_it2_modality_martial_arts(inputs)
	return en_us2_modality_martial_arts(inputs)
});
export { modality_martial_arts as "modality.martial_arts" }